/* generated by pull.js */
const manifest = {
    editorOnly: true,
    name: 'Insert blocks by name',
    description: 'Middle or shift-click the code area, or press Ctrl+Space to bring up a block search window. Type block names (or parts of them) and drag them into the code area to add them to your project. The menu can be navigated with the arrow keys, Page Up/Down, Home/End, and Enter. It supports autocompleting with Tab. To prevent the menu from closing, hold Shift while dragging blocks out of it.',
    credits: [
        {
            name: 'Tacodiva',
            link: 'https://scratch.mit.edu/users/Tacodiva7729/'
        },
        {
            name: 'griffpatch'
        },
        {
            name: 'TheColaber',
            link: 'https://scratch.mit.edu/users/TheColaber/'
        },
        {
            name: 'CST1229',
            link: 'https://scratch.mit.edu/users/CST1229/'
        }
    ],
    tags: [
        'recommended'
    ],
    enabledByDefault: true,
    userscripts: [
        {
            url: 'userscript.js'
        }
    ],
    userstyles: [
        {
            url: 'userstyle.css'
        }
    ],
    settings: [
        {
            dynamic: true,
            name: 'Popup Block Size',
            id: 'popup_scale',
            type: 'integer',
            min: 1,
            max: 100,
            default: 48
        },
        {
            dynamic: true,
            name: 'Popup Width',
            id: 'popup_width',
            type: 'integer',
            min: 1,
            max: 100,
            default: 30
        },
        {
            dynamic: true,
            name: 'Popup Maximum Height',
            id: 'popup_max_height',
            type: 'integer',
            min: 1,
            max: 100,
            default: 40
        }
    ],
    info: [
        {
            text: 'This addon was previously part of the "developer tools" addon but has moved here.',
            id: 'developer-tools'
        },
        {
            text: 'You can now perform math calculations directly in the search (e.g., "10 + 5 * 2") and see the result in a green box. Unit conversions support flexible queries like "5cm in inches", "what is 100 km to miles", "25 c to f". Supports distance (mm, cm, m, km, in, ft, yd, mi), temperature (c, f, k), weight (mg, g, kg, oz, lb, ton), time (ms, s, min, hr, day, week), and angles (deg, rad, grad).',
            id: 'math-and-conversions'
        }
    ]
};
export default manifest;
